import { combineReducers } from "redux";

import { typesFor } from "./types";

const rootReducer = combineReducers({
  worklist: createSortReducer("worklist", { field: "Claim", type: "asc" })
});

function createSortReducer(domain, initialState = { field: null, type: null }) {
  const types = typesFor(domain);

  return (state = initialState, action) => {
    switch (action.type) {
      case types.SET_SORT:
        return { field: action.payload.field, type: action.payload.type };
      default:
        return state;
    }
  };
}

export default rootReducer;
